module.exports = __webpack_public_path__ + "static/img/single_good2.a37a4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/single_good2.png
// module id = GcMj
// module chunks = 1